import { fork, put, takeLatest } from 'redux-saga/effects';
import { getType } from '../../utils';
import actions from './actions';
export function* loadUserActivities(api, action) {
    const { userId, clientId, skip = 0, limit = 20, startAt, endAt, search } = action.payload;
    try {
        const data = yield api
            .getActivities({
            userId,
            clientId,
            skip,
            limit,
            startAt,
            endAt,
            search,
        })
            .then((p) => p.request);
        yield put(actions.loadUserActivitiesSuccess(data));
    }
    catch (error) {
        yield put(actions.loadUserActivitiesError(error));
    }
}
export function* replayUserActivity(api, action) {
    const { activityId, clientId } = action.payload;
    try {
        yield api
            .replayActivity({ activityId, clientId })
            .then((p) => p.request);
        yield put(actions.replayUserActivitySuccess({ activityId, clientId }));
    }
    catch (error) {
        yield put(actions.replayUserActivityError(error));
    }
}
export function* createUserActivity(api, action) {
    const { activity, userId, clientId } = action.payload;
    try {
        yield api
            .createActivity({ activity, userId, clientId })
            .then((p) => p.request);
        yield put(actions.createUserActivitySuccess());
    }
    catch (error) {
        yield put(actions.createUserActivityError(error));
    }
}
export function* editUserActivity(api, action) {
    const { activity, userId } = action.payload;
    try {
        yield api
            .editActivity({ activity, userId })
            .then((p) => p.request);
        yield put(actions.editUserActivitySuccess({ activityId: activity._id }));
    }
    catch (error) {
        yield put(actions.editUserActivityError(error));
    }
}
export function* deleteUserActivity(api, action) {
    const { activityId, userId, clientId } = action.payload;
    try {
        yield api
            .deleteActivity({ activityId, userId, clientId })
            .then((p) => p.request);
        yield put(actions.deleteUserActivitySuccess({ activityId }));
    }
    catch (error) {
        yield put(actions.deleteUserActivityError(error));
    }
}
export function* watchLoadUserActivities(api) {
    yield takeLatest(getType(actions.loadUserActivities), loadUserActivities, api);
}
export function* watchReplayUserActivity(api) {
    yield takeLatest(getType(actions.replayUserActivity), replayUserActivity, api);
}
export function* watchCreateUserActivity(api) {
    yield takeLatest(getType(actions.createUserActivity), createUserActivity, api);
}
export function* watchEditUserActivity(api) {
    yield takeLatest(getType(actions.editUserActivity), editUserActivity, api);
}
export function* watchDeleteUserActivity(api) {
    yield takeLatest(getType(actions.deleteUserActivity), deleteUserActivity, api);
}
export const userActivitiesSagas = (api) => [
    fork(watchLoadUserActivities, api),
    fork(watchReplayUserActivity, api),
    fork(watchCreateUserActivity, api),
    fork(watchEditUserActivity, api),
    fork(watchDeleteUserActivity, api),
];
export default userActivitiesSagas;
